<template>
  <div class="connect">
    <h2>Réinitialisation du mot de passe</h2>
  </div>
  <div class="login-section">
    <div v-if="error" class="error-msg">
      Ce lien est invalide ou a expiré. Veuillez refaire une demande.
    </div>
    <div v-else>
      <form @submit.prevent="submitPassword">
          <div class="input-group">
              <label for="password" class="input-label mdp">Mot de passe*
              <div class="tooltip-container">
                  <i class="bi bi-info-circle"></i>
                  <div class="tooltip-content">
                  Il faut au minimum 8 caractères dont au moins : <br>- une majuscule <br>- une minuscule <br>- un nombre <br>- un caractère spécial de la série '@ $ ! % * ? &amp; _ # + = - ^ ‘ ( ) " « { } . , : ; &lt; &gt; [ ] ` | ~ \ / € £ µ § ¥ ¢'<br> -Les espaces, accents et autres caractères spéciaux ne sont pas acceptés
                  </div>
              </div>
          </label>
          <div class="password-wrapper">
          <input v-if="showPassword" v-model="password" type="text" class="input-control" id="password" placeholder="Mot de passe" autocomplete="new-password">
          <input v-else v-model="password" type="password" class="input-control" id="password" placeholder="Mot de passe" autocomplete="new-password" required>
              <div @click="toggleShow1" class="eye-icon">
                  <i class="bi" :class="{ 'bi-eye-slash-fill': showPassword, 'bi-eye-fill': !showPassword }"></i>
              </div>
          </div>
          </div>
          <div class="input-group">
              <label for="confirmPassword" class="input-label">Confirmer le mot de passe*</label>
              <div class="password-wrapper">
                  <input v-if="showPassword2" v-model="confirmPassword" type="text" class="input-control" id="confirmPassword" placeholder="Confirmer mot de passe" autocomplete="hidden" required>
                  <input v-else v-model="confirmPassword" type="password" class="input-control" id="confirmPassword" placeholder="Confirmer mot de passe" autocomplete="hidden" required>
                  <div @click="toggleShow2" class="eye-icon">
                      <i class="bi" :class="{ 'bi-eye-slash-fill': showPassword2, 'bi-eye-fill': !showPassword2 }"></i>
                  </div>
              </div>
            </div>
            <p v-if="passwordMismatch" class="error-text">Les mots de passe ne correspondent pas.</p>
            <div class="form-footer">
              <button type="submit" :disabled="loading || passwordMismatch">Valider</button>
              <button @click="this.$router.push(`/login`)" class="back-button">Retour dans la page d'accueil</button>
            </div>    
      </form>
    </div>
  </div>
</template>

<script>
var pwdRules =
    "Il faut au minimum 8 caractères dont au moins : \n" +
    "- une majuscule \n" +
    "- une minuscule \n" +
    "- un nombre \n" +
    "un caractère spécial de la série '@ $ ! % * ? & _ # + = - ^ ‘ ( ) \" « { } . , : ; < > [ ] ` | ~ \\ / € £ µ § ¥ ¢'\n" +
    "-Les espaces, accents et autres caractères spéciaux ne sont pas acceptés";
import { mapState } from 'vuex';
import '../../assets/styles/modal.css'
import '../../assets/styles/base.css'
/* import { jwtDecode } from "jwt-decode"; */

export default {
  name: "ResetPassword",
  data() {
    return {
      token: "",
      password: "",
      confirmPassword: "",
      error: false,
      loading: false,
      showPassword:false,
      showPassword2:false,
    };
  },
  computed: {
  ...mapState('auth', ['isAuthenticated', 'user'/* , 'token' */, 'respStatus', 'emailState', 'tempToken']),
    passwordMismatch() {
      return this.password && this.confirmPassword && (this.password !== this.confirmPassword);
    }
  },
  mounted() {
    this.token = this.$route.params.token;
  },
  methods: {
    async submitPassword() {
      if (this.passwordMismatch) return;
      // eslint-disable-next-line no-useless-escape
      var goodPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_#+=\-\^‘'()"«{}.,:;<>\[\]`|~\\\/€£µ§¥¢])[a-zA-Z\d@$!%*?&_#+=\-\^‘'()"«{}.,:;<>\[\]`|~\\\/€£µ§¥¢]{8,}$/;
      if(!this.password.match(goodPassword)){
        alert("Mauvais format de mot de passe !!! \n" + pwdRules);
        return;
      }
      this.loading = true;
      try {
        const payload = {
          token: this.token,
          password: this.password
        }
        await this.$store.dispatch(`auth/changePassword`, payload);
        alert("Mot de passe modifié avec succès ! Vous allez être redirigé.");
        this.$store.commit(`auth/clearAuth`)
        this.$router.push('/login');
      } catch (err) {
        console.error("error reset :", err, err.data, err.data?.message);
        alert("Error: " + err.data);
      } finally {
        this.loading = false;
      }
    },
    toggleShow1() {
      this.showPassword = !this.showPassword;
    },
    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    }
  }
};
</script>
<style scoped>
  .connect {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
  
  .login-section {
    max-width: 450px;
    margin: auto auto;

  }
  
  .compact-form {
    padding: 14px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(255, 172, 172, 0.5);
    margin-bottom: 16px;
  }
  
  .input-group {
    margin-bottom: 16px;
  }
  
  .input-label {
    font-weight: 600;
    font-size: 0.9rem;
    display: block;
    margin-bottom: 4px;
    color: #2c3e50;
  }
  
  .input-control {
    width: 100%;
    padding: 8px 12px;
    font-size: 0.9rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: rgba(245, 245, 245, 0.031);
  }
  
  .password-wrapper {
    position: relative;
    display: flex;
  }
  
  .password-wrapper .input-control {
    flex: 1;
    padding-right: 40px;
  }
  
  .eye-icon {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .bi {
    font-size: 1rem;
    color: var(--text-color);
    padding: 0 12px;
  }
  
  .form-footer {
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    margin-top: 16px;
  }

  button{
    padding: 1vh 1.75vw;
  }
  
/*   a {
    color: var(--primary-color);
    text-decoration: none;
    transition: all 0.3s ease;
    margin: 8px 0 0 75px;
    text-align: center;
  }
  
  a:hover {
    color: var(--primary-color);
    text-decoration: underline;
  } */

  .register-link {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 16px 75px 0 0;
  }

  .tooltip-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin-left: 5px;
  height: 19px;
}


.tooltip-content {
display: none;
position: absolute;
top: -130px;
left: 40px;
background-color: #f9f9f9;
color: var(--text-color);
border: 1px solid #ccc;
border-radius: 4px;
padding: 8px;
width: 220px;
box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.tooltip-container:hover .tooltip-content {
display: block;
}

.error-msg { color: red; font-weight: bold; }
.error-text { color: red; font-size: 0.9em; }

  </style>